import type { TCard, TFilterCategory } from "@/components";
import { getResultsUrl } from "@/utils/search.utils";
import { format } from "date-fns";
import type { Hit, BaseHit } from "instantsearch.js";

const fromSearchDto = (
	dto: Hit<BaseHit>,
	filter: TFilterCategory | undefined
): Partial<TCard | undefined> => {
	if (!dto) return;

	const card = {
		title: dto.name,
		description: dto.description,
		type: dto.type,
		link: { url: getResultsUrl(dto) },
	};

	if (filter) {
		if (filter.id === dto.type) {
			return card;
		}
	} else return card;
};

export default fromSearchDto;
